/// <reference types="./svg.d.mts" />
import * as $int from "../../../gleam_stdlib/gleam/int.mjs";
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import * as $a from "../../../lustre/lustre/attribute.mjs";
import * as $element from "../../../lustre/lustre/element.mjs";
import { toList, prepend as listPrepend } from "../../gleam.mjs";

function compute_view_box(width, height) {
  let width$1 = $int.to_string(width);
  let height$1 = $int.to_string(height);
  return $string.join(toList(["0", "0", width$1, height$1]), " ");
}

const xmlns = "http://www.w3.org/2000/svg";

export function view_(width, height, attrs, content) {
  let viewbox = compute_view_box(width, height);
  let viewbox$1 = $a.attribute("viewBox", viewbox);
  let fill = $a.attribute("fill", "none");
  let ns = $a.attribute("xmlns", xmlns);
  return $element.unsafe_raw_html(
    xmlns,
    "svg",
    listPrepend(viewbox$1, listPrepend(fill, listPrepend(ns, attrs))),
    content,
  );
}

export function view(width, height, content) {
  return view_(width, height, toList([]), content);
}

export function square(size, content) {
  return view(size, size, content);
}

export function square_(size, attributes, content) {
  return view_(size, size, attributes, content);
}
